import gql from "graphql-tag";

// TODO: This is entirely stolen from PhotoSearchResults/queries.js.
// Not sure whether it should be moved to a shared location, or if
// the duplication is fine for now.

const ItemsPartsFragment = gql`
    fragment ItemsParts on PhotoType {
        id
        slugWithId
        title
        creator {
            name
            username
            country
            description
        }
        assets {
            thumbnailSmall
            thumbnailMedium
        }
        ratio
    }
`;

export const GET_PHOTOS_BY_CREATOR = gql`
    query browsePhotosByCreator($creator: String!, $limit: Int, $offset: Int) {
        browsePhotosByCreator(
            creator: $creator
            limit: $limit
            offset: $offset
        ) {
            items {
                ...ItemsParts
            }
            totalCount
        }
    }
    ${ItemsPartsFragment}
`;
